import React ,{useState}from 'react'
import Skeleton from '@material-ui/lab/Skeleton';
export default function LoadingCard() {

   
    return (
        <div>
            <div className='card-wrapper'>
                <div className='card-header'>
                    <div className='header-profile div-flex div-align-center'>
                         <Skeleton animation="wave" variant="circle" width={40} height={40} />
                        &nbsp;&nbsp;
                        <div className='header-author div-flex'>
                            <Skeleton animation="wave" height={20} width={100} style={{ marginBottom: 6 }} />
                        </div>
                    </div>
                    <div className='header-timestamp'>
                        <Skeleton animation="wave" height={20} width={50} style={{ marginBottom: 6 }} />
                    </div>
                </div>
                <div className='card-content'>
                    <Skeleton animation="wave" height={20} style={{ marginBottom: 6 ,marginTop:20}} />
                    <Skeleton animation="wave" height={20} style={{ marginBottom: 2 }} />
                    <Skeleton animation="wave" height={20} width="80%" />
                </div>
                <Skeleton animation="wave" variant="rect" width="100%" height={200}/>
                <div className='card-footer'>
                    <div className='hashtag-section'>
                        <Skeleton animation="wave" height={20} width="100%" style={{ marginBottom: 6 }} />
                    </div>
                    <div className='div-flex'>
                        <Skeleton animation="wave" height={20} width={100} style={{ marginBottom: 6 }} />
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
